import { MainCard, MainCardTitle } from "src/components/main-card-type.tsx";
import { normalSanatizerBRL } from "src/utils/functions";
import { ResultSalario } from "../Ferias";
import { FeriasTable } from "./FeriasTable";
export const FeriasResponse = ({ results }: { results: ResultSalario }) => {
  return (
    <MainCard className="mt-4">
      <MainCardTitle>Resultado</MainCardTitle>
      <div className="grid sm:grid-cols-3 gap-4 mb-2 grid-cols-1">
        <div className="p-3 bg-primary rounded border flex flex-col justify-center">
          <h2 className="sm:text-base text-sm text-center text-white font-semibold m-0">
            Salario de ferias liquido
          </h2>
          <p className="sm:text-xl text-center font-bold text-md text-white m-0">
            <span className="text-sm mr-1 text-white">R$</span>
            {normalSanatizerBRL(results.valorfinal)}
          </p>
        </div>
      </div>
      <FeriasTable results={results} />
    </MainCard>
  );
};
